import { ContainerComponent, today, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { TimeSpanRow } from 'molecules';
import { GenericWrapper } from 'wrappers';
import { format, subDays, subYears } from 'date-fns';

export const definition = {
  name: 'DatePickerButtons',
  controller: Controller,
  initialProps: ({ startDate, endDate, selectedTimeSpan, displayIcon }) => ({ startDate, endDate, selectedTimeSpan, displayIcon }),
  props: internalState,
  elements: [
    {
      component: TimeSpanRow,
      name: 'Today',
      bindings: ({ selectedTimeSpan, displayIcon }) => ({
        label: 'Today',
        selected: selectedTimeSpan === 'today',
        displayIcon
      }),
      displayState: ({ selectedTimeSpan }) => ({ selected: selectedTimeSpan === 'today' })
    },
    {
      component: TimeSpanRow,
      name: 'LastWeek',
      bindings: ({ selectedTimeSpan, displayIcon }) => ({
        label: 'Last 7 Days',
        startDate: format(subDays(today(), 6), 'MM/dd/yy'),
        endDate: format(today(), 'MM/dd/yy'),
        selected: selectedTimeSpan === 'lastWeek',
        displayIcon
      }),
      displayState: ({ selectedTimeSpan }) => ({ selected: selectedTimeSpan === 'lastWeek' })
    },
    {
      component: TimeSpanRow,
      name: 'LastMonth',
      bindings: ({ selectedTimeSpan, displayIcon }) => ({
        label: 'Last 30 Days',
        startDate: format(subDays(today(), 29), 'MM/dd/yy'),
        endDate: format(today(), 'MM/dd/yy'),
        selected: selectedTimeSpan === 'lastMonth',
        displayIcon
      }),
      displayState: ({ selectedTimeSpan }) => ({ selected: selectedTimeSpan === 'lastMonth' })
    },
    {
      component: TimeSpanRow,
      name: 'LastYear',
      bindings: ({ selectedTimeSpan, displayIcon }) => ({
        label: 'Last 12 Months',
        startDate: format(subYears(today(), 1), 'MM/dd/yy'),
        endDate: format(today(), 'MM/dd/yy'),
        selected: selectedTimeSpan === 'lastYear',
        displayIcon
      }),
      displayState: ({ selectedTimeSpan }) => ({ selected: selectedTimeSpan === 'lastYear' })
    },
    {
      component: TimeSpanRow,
      name: 'AllTime',
      bindings: ({ selectedTimeSpan, displayIcon }) => ({
        label: 'All Time',
        selected: selectedTimeSpan === 'allTime',
        displayIcon
      }),
      displayState: ({ selectedTimeSpan }) => ({ selected: selectedTimeSpan === 'allTime' })
    },
    {
      component: TimeSpanRow,
      name: 'Custom',
      bindings: ({ selectedTimeSpan, displayIcon, startDate, endDate }) => ({
        label: 'Custom',
        selected: selectedTimeSpan === 'custom',
        displayIcon,
        start: startDate,
        end: endDate
      }),
      displayState: ({ selectedTimeSpan }) => ({ selected: selectedTimeSpan === 'custom' })
    },
    {
      component: TimeSpanRow,
      name: 'MTD',
      bindings: ({ selectedTimeSpan, displayIcon }) => ({
        label: 'Month to date',
        selected: selectedTimeSpan === 'mtd',
        displayIcon
      }),
      displayState: ({ selectedTimeSpan }) => ({ selected: selectedTimeSpan === 'mtd' })
    },
    {
      component: TimeSpanRow,
      name: 'YTD',
      bindings: ({ selectedTimeSpan, displayIcon }) => ({
        label: 'Year to date',
        selected: selectedTimeSpan === 'ytd',
        displayIcon
      }),
      displayState: ({ selectedTimeSpan }) => ({ selected: selectedTimeSpan === 'ytd' })
    },
  ]
};

export default wrap(ContainerComponent(definition), GenericWrapper);